// Bookingsiden åbnet under et subdomæne/brand (fx SteamFox): widget'en på brandets hjemmeside sender ?brand=steamfox.
// Valget huskes i fanen (sessionStorage), så bekræftelsessiden og "Book igen" også er i brandets look.
// Brandets visning (navn og logo) deles med topbjælken via en lille butik.
import { useSyncExternalStore } from 'react';

const NOEGLE = 'freemi-brand';
const gyldig = (v: string | null | undefined): v is string => !!v && /^[a-z0-9][a-z0-9-]{1,39}$/.test(v);

/** Brandet for den aktuelle side: fra adressen (#/book?brand=…), ellers det, fanen sidst brugte. */
export function brandNu(): string | null {
  if (typeof location === 'undefined') return null;
  const q = new URLSearchParams(location.hash.split('?')[1] ?? '');
  const v = q.get('brand');
  if (gyldig(v)) { try { sessionStorage.setItem(NOEGLE, v); } catch { /* ok */ } return v; }
  try { const s = sessionStorage.getItem(NOEGLE); return gyldig(s) ? s : null; } catch { return null; }
}

export type BrandVisning = { id: string; navn: string; logo: string | null };
let aktiv: BrandVisning | null = null;
const lyttere = new Set<() => void>();
export function saetBrandVisning(b: BrandVisning | null) {
  if (aktiv?.id === b?.id && aktiv?.logo === b?.logo && aktiv?.navn === b?.navn) return;
  aktiv = b; lyttere.forEach((f) => f());
}
export function useBrandVisning(): BrandVisning | null {
  return useSyncExternalStore((f) => { lyttere.add(f); return () => { lyttere.delete(f); }; }, () => aktiv, () => null);
}
